// extracted by mini-css-extract-plugin
module.exports = {"root":"FlowSequenceStatsView_root__105jW","filters":"FlowSequenceStatsView_filters__2rNKy","tabs":"FlowSequenceStatsView_tabs__3b_GD","body":"FlowSequenceStatsView_body__8XVgG"};